import {useUrlSearchParams} from "@/helpers/url.helper";
import {reactive} from "vue";
import {format} from "date-fns";

export interface UseFilters<T> {
    filters: T;
    setFilter: (filter: keyof T, value: any) => void;
    clearFilter: () => void;
}

export const useFilters = <T extends object>(initialFilter: T, callback?: () => any): UseFilters<T> => {
    const filters = reactive({...initialFilter}) as T;
    const searchParams = useUrlSearchParams();

    const setFilter = (filter: keyof T, value: any) => {
        if (Array.isArray(value)) {
            Object.assign(filters, {[filter]: value});
            searchParams.setParamArray(filter as string, value);
        } else if(Object.prototype.toString.call(value) === '[object Date]') {
            Object.assign(filters, {[filter]: value});
            const formattedDate = format(value, "dd-MM-yyyy");
            searchParams.setParam(filter as string, formattedDate);
        } else {
            Object.assign(filters, {[filter]: value});
            searchParams.setParam(filter as string, value);
        }

        if (initialFilter[filter] === value) {
            // Value is same as the initial, so this won't have to be stored
            searchParams.setParam(filter as string, undefined);
        }
        
        if (callback) callback();
    }

    const clearFilter = () => {
        Object.assign(filters, initialFilter);
        searchParams.clearParams();

        if (callback) {
            callback();
        }
    }

    return {filters, setFilter, clearFilter};
}
